import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import ReactEcharts from 'echarts-for-react'
import Sticky from 'react-stickynode'
import { library } from '@fortawesome/fontawesome-svg-core'
import { loadFromUrl, loadPairs, loadPerformance, setFund, setBmk, setDate, setPeriod, setCategory, setSort, saveToGA, loadAttributionExcel } from '../../actions'
import { isMobileOnly } from 'react-device-detect'
import i18n from '../../i18n'
import { CopyToClipboard } from 'react-copy-to-clipboard'
import { faCircleNotch } from '@fortawesome/free-solid-svg-icons'
import './style.css'
import DetailsTable from './DetailsTable/FundDetailsTable.js'
import ActivityIndicator from './ActivityIndicator/ActivityIndicator.js'
library.add(faCircleNotch)

class App extends Component {
  componentWillMount() {
    let { history } = this.props

    this.props.loadPairs().then(() => {
      const hash = history.location.hash.substring(1)
      if (hash !== '') {
        const hash = history.location.hash.substring(1).split('&')
        this.hashActions(hash)
      }
    })

    history.listen(() => {
      const hash = history.location.hash.substring(1).split('&')
      this.hashActions(hash)
    })
  }

  hashActions = hash => {
    if (hash.length > 1 && (hash[0] === 'fundattr' || hash[0] === 'fund-attribution')) {
      if (hash[1].includes('fund')) {
        const fund = hash[1].split('fund=')[1]
        const bmk = hash[2].split('bmk=')[1]
        const date = hash[3].split('urlDate=')[1]
        const category = decodeURI(hash[4].split('urlCategory=')[1])
        const period = hash[5].split('urlPeriod=')[1]
        this.props.loadFromUrl(fund, bmk, date, category, period)
      }
    }
  }

  setFund(idx) {
    this.props.setFund(idx)
  }

  setBmk(pair) {
    this.props.setBmk(pair)
  }

  setDate(date) {
    this.props.setDate(date)
  }

  setPeriod(period) {
    this.props.setPeriod(period)
  }

  setCategory(cat) {
    this.props.setCategory(cat)
  }

  renderFunds() {
    if (this.props.pairs) {
      // get unique indexes from the pairs
      let indexes = Array.from(this.props.pairs.reduce((m, t) => m.set(t.fund, t), new Map()).values())
      // fill in the category based on cat1 and cat2
      indexes = indexes.map(item => {
        item.category = ''
        if (item.fund_category_tier1) {
          item.category = item.fund_category_tier1 + (item.fund_category_tier2 ? ' - ' + item.fund_category_tier2 : '')
        } else {
          item.category = 'Other'
        }
        return item
      })
      // get unique categories and sort
      let categories = Array.from(indexes.reduce((m, t) => m.set(t.category, t.category), new Map()).values()).sort()
      // return index selection options grouped by category
      return categories.map(category => (
        <optgroup key={category} label={category}>
          {this.getCategoryOptions(indexes, category)}
        </optgroup>
      ))
    } else {
      return null
    }
  }

  getCategoryOptions(indexes, category) {
    let filtered = indexes.filter(index => index.category === category)
    return filtered.map(item => (
      <option key={item.fund} value={item.fund}>
        {item.fund} - {item.fund_name}
      </option>
    ))
  }

  renderBmks() {
    if (this.props.pairs) {
      let fund = this.props.fund
      let benchmarks = this.props.pairs.filter(function (value) {
        return value.fund === fund
      })
      return benchmarks.map((item, index) => (
        <option key={item.bmk} value={item.bmk}>
          {item.bmk} - {item.bmk_name}
        </option>
      ))
    } else {
      return null
    }
  }

  reorderCategories(categories) {
    var newCats = []
    if (categories.includes('sector')) newCats.push('sector')
    if (categories.includes('country')) newCats.push('country')
    if (categories.includes('dy_qtl')) newCats.push('dy_qtl')
    if (categories.includes('ey_qtl')) newCats.push('ey_qtl')
    if (categories.includes('roe_qtl')) newCats.push('roe_qtl')
    if (categories.includes('sy_qtl')) newCats.push('sy_qtl')
    if (categories.includes('soe')) newCats.push('soe')
    if (categories.includes('wtsize')) newCats.push('wtsize')
    if (categories.includes('vol_qtl')) newCats.push('vol_qtl')
    return newCats
  }

  renderCategories() {
    if (this.props.categories) {
      function attrCatName(value) {
        switch (value) {
          case 'sy_qtl':
            return i18n.t('Shareholder Yield Attribution')
          case 'wtsize':
            return i18n.t('Size Attribution')
          case 'roe_qtl':
            return i18n.t('Return on Equity Attribution')
          case 'ey_qtl':
            return i18n.t('Earnings Yield Attribution')
          case 'dy_qtl':
            return i18n.t('Dividend Yield Attribution')
          case 'sector':
            return i18n.t('Sector Attribution')
          case 'country':
            return i18n.t('Country Attribution')
          case 'vol_qtl':
            return i18n.t('Volatility Attribution')
          case 'soe':
            return i18n.t('State-Ownership Attribution')
          default:
            return value
        }
      }
      let sortedCats = this.reorderCategories(this.props.categories)
      return sortedCats.map((cat, index) => (
        <option key={cat} value={cat}>
          {attrCatName(cat)}
        </option>
      ))
    } else {
      return null
    }
  }

  renderGlossary() {
    if (this.props.categories) {
      function attrCatGlossary(value) {
        switch (value) {
          case 'SY_Qtl':
            return i18n.t('SY-gloss')
          case 'ROE':
            return i18n.t('ROE-gloss')
          case 'EY_Qtl':
            return i18n.t('EY-gloss')
          case 'DY_Qtl':
            return i18n.t('DY-gloss')
          default:
            return null
        }
      }
      let result = attrCatGlossary(this.props.category)
      return <div className='perffooter'>{result}</div>
    } else {
      return null
    }
  }

  renderPeriods() {
    if (this.props.categoryData) {
      function checkForSI(value) {
        return value === 'SI' ? i18n.t('Since Inception') + '*' : value
      }
      let periodsA = ['MTD', 'QTD', 'YTD', '1Y', '3Y', '5Y', '10Y', 'SI']
      const periodsB = [...new Set(this.props.categoryData.map(x => x.period))].sort()
      const periods = periodsA.filter(value => periodsB.includes(value))
      return periods.map((period, index) => (
        <button id={'btn' + period} key={period} className={this.buttonPeriodClass(period)} onClick={() => this.setPeriod(period)}>
          {checkForSI(period)}
        </button>
      ))
    } else {
      return null
    }
  }

  getDateCode(theDate) {
    return new Date(theDate).toISOString().replace('-', '').split('T')[0].replace('-', '')
  }

  renderDates() {
    if (this.props.dates) {
      return this.props.dates.map((date, index) => (
        <option key={index} value={this.getDateCode(date.curr_date)}>
          {new Date(date.curr_date).toLocaleDateString().split(',')[0]}
        </option>
      ))
    } else {
      return null
    }
  }

  getSaveToGA = (event, val) => {
    event.preventDefault()
    if (val === 'link') {
      this.props.saveToGA('copy link')
    } else {
      this.props.saveToGA('excel download')
    }
  }

  getExcelDownload = event => {
    event.preventDefault()
    this.props.loadAttributionExcel()
  }

  getAsOfDate() {
    if (this.props.periodData.length > 0) {
      return this.getDateCode(this.props.periodData[0].curr_date)
    } else {
      return ''
    }
  }
  toSentenceCase = str => {
    if (!str) return str
    return str
      .split(' ')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(' ')
  }
  convPerc(value) {
    return Number.parseFloat(value * 100).toFixed(2)
  }

  renderTable() {
    if (this.props.periodData) {
      return this.props.periodData.map((item, index) => (
        <tr key={index} style={{ fontWeight: item.category === 'Total' ? 'bold' : '500' }}>
          <td className='capitalize' rowname='Category'>
            {item.category}
          </td>
          <td rowname='Allocation'>{this.convPerc(item.allocation)}%</td>
          <td rowname='Stock Selection'>{this.convPerc(item.selection)}%</td>
          <td rowname='Interaction'>{this.convPerc(item.interaction)}%</td>
          <td rowname='Total Attribution'>{this.convPerc(item.total)}%</td>
          <td rowname='Fund Weight'>{item.category !== 'Total' ? this.convPerc(item.index_wgt) + '%' : '-'}</td>
          <td rowname='Competitor Weight'>{item.category !== 'Total' ? this.convPerc(item.benchmark_wgt) + '%' : '-'}</td>
          <td rowname='+ / - Weight'>{item.category !== 'Total' ? this.convPerc(item.active_wgt) + '%' : '-'}</td>
          <td rowname='Fund Returns'>{this.convPerc(item.index_group_ret)}%</td>
          <td rowname='Competitor Returns'>{this.convPerc(item.benchmark_group_ret)}%</td>
        </tr>
      ))
    } else {
      return null
    }
  }

  buttonPeriodClass(type) {
    return type === this.props.period ? 'button-selected' : ''
  }

  setSortData(column) {
    this.props.setSort(column)
  }

  setTblHeadClass(type) {
    if (type === this.props.sortColumn && this.props.sortDirection === 'DESC') {
      return 'des'
    } else if (type === this.props.sortColumn && this.props.sortDirection === 'ASC') {
      return 'asc'
    } else {
      return ''
    }
  }

  renderFooter() {
    const { pairs, fund } = this.props
    const selectedFund = pairs.find(pair => pair.fund === fund)
    let fundURL = selectedFund.url
    if (!fundURL) {
      fundURL = `https://www.morningstar.com/etfs/arcx/${fund}/performance`
    }

    const prospectusURL = 'https://www.wisdomtree.com/investments/resource-library/prospectus-regulatory-reports'

    let inceptionDt = new Date(selectedFund.inceptionDt + 'T00:00:00')

    let dateFormat = {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit'
    }

    if (!pairs || pairs.length === 0) {
      return null
    }

    return (
      <div>
        <div className='perffooter'>
          {i18n.t('comp-source')} {i18n.t('inception-date')}: {new Date(inceptionDt).toLocaleString('en-US', dateFormat)}&nbsp;&nbsp;&nbsp; {i18n.t('comp-view')}
          <a href={fundURL} target='_blank' rel='noopener noreferrer'>
            {i18n.t('here')}
          </a>
          , {i18n.t('other')}
          &nbsp; {i18n.t('prospectus')} &nbsp;
          <a href={prospectusURL} target='_blank' rel='noopener noreferrer'>
            {i18n.t('here_prospectus')}
          </a>
        </div>
        <div className='perffooter'>{i18n.t('comp-inception')}</div>
        {this.renderGlossary()}
        <div className='perffooter'>{i18n.t('Composite Risk Score')}</div>
        <div className='perffooter'>{i18n.t('comp-universe')}</div>
        <div className='perffooter'>
          <span style={{ fontWeight: 'bold' }}>{i18n.t('average-weights')} </span>
          {i18n.t('comp-average')} <span style={{ fontWeight: 'bold' }}>{i18n.t('Allocation')} </span>
          {i18n.t('comp-allocation')} <span style={{ fontWeight: 'bold' }}>{i18n.t('Selection')} </span>
          {i18n.t('comp-selection')} <span style={{ fontWeight: 'bold' }}>{i18n.t('Interaction')} </span>
          {i18n.t('comp-interaction')}
        </div>
        <div className='perffooter'>{i18n.t('attribution-def')}</div>
        <div className='perffooter-b'>{i18n.t('comp-past')}</div>
        {/* <div className='perffooter-b'>{i18n.t('comp-std')}</div> */}
        {/* <div className='perffooter-b'>{i18n.t('comp-prospectus')}</div> */}
        <br /> <br />
      </div>
    )
  }

  render() {
    const currentURL = window.location.href

    const { pairs, fund, bmk } = this.props

    if (!pairs || pairs.length === 0) {
      return <ActivityIndicator />
    }

    //let dateFormat = { month: 'numeric', day: 'numeric', year: 'numeric' }
    return (
      <div className='perf-attr'>
        <div className='perf-btn-toolbar' role='toolbar'>
          <Sticky innerZ={5} enabled={false} top={0}>
            <div style={{ backgroundColor: 'white', paddingBottom: '10px' }}>
              <div className='row'>
                <div className='col-md-6 perf-btn-group'>
                  <select onChange={event => this.setFund(event.target.value)} value={this.props.fund}>
                    {!this.props.fund && <option value=''>{i18n.t('Select a WisdomTree Fund')}</option>}
                    {this.renderFunds()}
                  </select>
                </div>
                {this.props.fund && <div className='col-md-1 perf-btn-group versus'>VS.</div>}
                {this.props.fund && (
                  <div className='col-md-5 perf-btn-group'>
                    <select style={{ fontSize: '13px' }} onChange={event => this.setBmk(event.target.value)} value={this.props.bmk}>
                      {!this.props.bmk && <option value=''>{i18n.t('Select a Benchmark')}</option>}
                      {this.renderBmks()}
                    </select>
                  </div>
                )}
              </div>

              {this.props.bmk && (
                <div className='row'>
                  <div className='col-md-3 perf-btn-group'>
                    <select onChange={event => this.setCategory(event.target.value)} value={this.props.category}>
                      {this.renderCategories()}
                    </select>
                  </div>
                  <div className='col-md-1 perf-btn-group'>
                    <div className='asofdate'>{i18n.t('As of')}:</div>
                  </div>
                  <div className='col-md-2 perf-btn-group'>
                    <select onChange={event => this.setDate(event.target.value)} value={this.getAsOfDate()}>
                      {this.renderDates()}
                    </select>
                  </div>
                  <div className='col-md-6 perf-btn-group'>
                    <div className='right'>{this.renderPeriods()}</div>
                  </div>
                </div>
              )}
            </div>
          </Sticky>
          {this.props.bmk && (
            <div>
              <div className='row'>
                <div className='col-md-12' style={{ padding: '0px' }}>
                  {/* <div className="right">
                  <a className={'downloadExcelLink'} onClick={(event) => this.getExcelDownload(event)}> DOWNLOAD EXCEL</a>
                  </div> */}
                  <div className='right' style={{ marginLeft: '10px' }}>
                    <CopyToClipboard text={currentURL}>
                      <a className={'downloadExcelLink'} onClick={event => this.getSaveToGA(event, 'link')}>
                        {' '}
                        COPY LINK
                      </a>
                    </CopyToClipboard>
                  </div>
                </div>
              </div>
              <div className='row'>
                <div className='perf-details col table-responsive' style={{ marginTop: '0px' }}>
                  <table className='table'>
                    <thead>
                      <tr className='first' style={{ fontStyle: 'italic' }}>
                        <th>&nbsp;</th>
                        <th colSpan='4'>{i18n.t('Attribution Component')}</th>
                        <th colSpan='3'>{i18n.t('Average Category Weight')}</th>
                        <th colSpan='2'>{i18n.t('Category Performance')}</th>
                      </tr>
                      <tr className='second'>
                        <th rowname='Category' className={'textLeft ' + this.setTblHeadClass('Category')} onClick={() => this.setSortData('Category')}>
                          {i18n.t('Category')}
                        </th>
                        <th rowname='Allocation' className={this.setTblHeadClass('Allocation')} onClick={() => this.setSortData('Allocation')} style={{ borderLeft: '1px solid white' }}>
                          {i18n.t('Allocation')}
                        </th>
                        <th rowname='Selection' className={this.setTblHeadClass('Selection')} onClick={() => this.setSortData('Selection')}>
                          Stock
                          <br />
                          {i18n.t('Selection')}
                        </th>
                        <th rowname='Interaction' className={this.setTblHeadClass('Interaction')} onClick={() => this.setSortData('Interaction')}>
                          {i18n.t('Interaction')}
                        </th>
                        <th rowname='Total' className={this.setTblHeadClass('Total')} onClick={() => this.setSortData('Total')}>
                          Total
                          <br />
                          {i18n.t('Attribution')}
                        </th>
                        <th rowname='IndexWgt' className={this.setTblHeadClass('IndexWgt')} onClick={() => this.setSortData('IndexWgt')} style={{ borderLeft: '1px solid white' }}>
                          WT {i18n.t('Fund')}
                          <br />
                          {i18n.t('Weight')}
                        </th>
                        <th rowname='BenchmarkWgt' className={this.setTblHeadClass('BenchmarkWgt')} onClick={() => this.setSortData('BenchmarkWgt')}>
                          {i18n.t('Competitor')}
                          <br />
                          {i18n.t('Weight')}
                        </th>
                        <th rowname='ActiveWgt' className={this.setTblHeadClass('ActiveWgt')} onClick={() => this.setSortData('ActiveWgt')}>
                          +/- {i18n.t('Wgt')}
                        </th>
                        <th rowname='IndexGroupRet' className={this.setTblHeadClass('IndexGroupRet')} onClick={() => this.setSortData('IndexGroupRet')} style={{ borderLeft: '1px solid white' }}>
                          WT {i18n.t('Fund')}
                          <br />
                          {i18n.t('Return')}
                        </th>
                        <th rowname='BenchmarkGroupRet' style={{ textAlign: 'center' }} className={this.setTblHeadClass('BenchmarkGroupRet')} onClick={() => this.setSortData('BenchmarkGroupRet')}>
                          {i18n.t('Competitor')}
                          <br />
                          {i18n.t('Return')}
                        </th>
                      </tr>
                    </thead>
                    <tbody>{this.renderTable()}</tbody>
                  </table>
                </div>
              </div>
              <div className='row'>
                <div className='perf-details col chart-container'>
                  <ReactEcharts option={this.getAttributionOption()} theme='default' style={{ height: 500 }} />
                </div>
              </div>
              <div className='row'>
                <div className='perf-details col-md-6 chart-container' style={{ borderRight: '5px solid white' }}>
                  <ReactEcharts option={this.getAverageWeightsOption()} theme='default' style={{ height: 400 }} />
                </div>

                <div className='perf-details col-md-6 chart-container' style={{ borderLeft: '5px solid white' }}>
                  <ReactEcharts option={this.getOverUnderOption()} theme='default' style={{ height: 400 }} />
                </div>
              </div>
              <DetailsTable fund={fund} bmk={bmk} />
              {this.renderFooter()}
            </div>
          )}
        </div>
      </div>
    )
  }

  getHBarOption() {
    return {
      title: {
        text: '',
        left: 12,
        textStyle: {
          fontStyle: 'normal',
          fontWeight: 400,
          fontSize: 15,
          color: '#07003C'
        }
      },
      legend: {
        data: [],
        itemGap: 20,
        right: 18,
        top: 30
      },
      tooltip: {
        trigger: 'axis',
        formatter: function (params, ticket) {
          var res = params[0].name
          for (var i = 0, l = params.length; i < l; i++) {
            res += '<br/>' + params[i].marker + ' ' + i18n.t(params[i].seriesName) + ' : ' + params[i].value + '%'
          }
          return res
        },
        backgroundColor: '#FFF',
        borderWidth: 1,
        borderColor: '#05A9B1',
        borderRadius: 0,
        textStyle: {
          color: '#07003C',
          align: 'left'
        }
      },
      grid: {
        left: '3%',
        right: '4%',
        bottom: '3%',
        containLabel: true
      },
      xAxis: [
        {
          type: 'value',
          axisLabel: {
            formatter: '{value} %'
          }
        }
      ],
      yAxis: [
        {
          type: 'category',
          axisLabel: {
            fontSize: 12,
            fontWeight: 400,
            color: '#07003C'
          },
          axisPointer: {
            type: 'shadow'
          },
          data: []
        }
      ],
      series: []
    }
  }

  filterOutTotal(data) {
    let categoryData = data.filter(function (value) {
      return value.category !== 'Total'
    })
    return categoryData
  }

  getAverageWeightsOption() {
    let indexLbl = i18n.t('Fund') + ' (' + this.props.fund + ')'
    let benchLbl = i18n.t('Benchmark') + ' (' + this.props.bmk + ')'
    let data = this.props.periodData
    let option = this.getHBarOption()
    option.title.text = i18n.t('Average Weights')
    option.legend.data = [indexLbl, benchLbl]
    let filteredData = this.filterOutTotal(data)
    option.yAxis[0].data = filteredData
      .map(row => this.toSentenceCase(i18n.t(row.category)))
      .slice()
      .reverse()
    option.series = [
      {
        type: 'bar',
        name: indexLbl,
        itemStyle: { color: 'darkblue' },
        data: filteredData
          .map(item => this.convPerc(item.index_wgt))
          .slice()
          .reverse()
      },
      {
        type: 'bar',
        name: benchLbl,
        itemStyle: { color: '#0fcbd4' },
        data: filteredData
          .map(item => this.convPerc(item.benchmark_wgt))
          .slice()
          .reverse()
      }
    ]
    return option
  }

  getOverUnderOption() {
    let data = this.props.periodData
    let option = this.getHBarOption()
    option.title.text = i18n.t('Over/Under Weight')
    option.legend.data = []
    let filteredData = this.filterOutTotal(data)
    option.yAxis[0].data = filteredData
      .map(row => this.toSentenceCase(i18n.t(row.category)))
      .slice()
      .reverse()
    option.series = [
      {
        type: 'bar',
        name: 'Index',
        itemStyle: { color: 'darkgreen' },
        data: filteredData
          .map(item => this.convPerc(item.active_wgt))
          .slice()
          .reverse()
      }
    ]
    return option
  }

  getVBarOption() {
    return {
      title: {
        text: '',
        left: 12,
        textStyle: {
          fontStyle: 'normal',
          fontWeight: 400,
          fontSize: 15,
          color: '#07003C'
        }
      },
      legend: {
        itemGap: 20,
        top: 30,
        data: []
      },
      tooltip: {
        trigger: 'axis',
        formatter: function (params, ticket) {
          var res = params[0].name
          for (var i = 0, l = params.length; i < l; i++) {
            res += '<br/>' + params[i].marker + ' ' + i18n.t(params[i].seriesName) + ' : ' + params[i].value + '%'
          }
          return res
        },
        backgroundColor: '#FFF',
        borderWidth: 1,
        borderColor: '#05A9B1',
        borderRadius: 0,
        textStyle: {
          color: 'textStyle',
          align: 'left'
        }
      },
      grid: {
        left: '3%',
        right: '4%',
        bottom: '3%',
        containLabel: true
      },
      xAxis: [
        {
          type: 'category',
          axisLabel: {
            fontSize: 12,
            fontWeight: 400,
            color: '#07003C',
            rotate: 45,
            interval: 0,
            align: 'right'
          },
          axisPointer: {
            type: 'shadow'
          },
          data: []
        }
      ],
      yAxis: [
        {
          type: 'value',
          axisLabel: {
            formatter: '{value} %'
          }
        }
      ],
      series: []
    }
  }

  getAttributionOption() {
    let data = this.props.periodData
    let option = this.getVBarOption()
    option.title.text = i18n.t('Performance Attribution')
    option.legend.data = [i18n.t('Allocation'), i18n.t('Selection'), i18n.t('Interaction'), i18n.t('Total Attribution')]
    if (isMobileOnly) {
      option.grid.top = 100
    }
    option.xAxis[0].data = data.map(row => this.toSentenceCase(i18n.t(row.category)))
    option.series = [
      {
        type: 'bar',
        stack: 'true',
        name: 'Allocation',
        itemStyle: { color: '#0fcbd4' },
        data: data.map(item => this.convPerc(item.allocation))
      },
      {
        type: 'bar',
        stack: 'true',
        name: 'Selection',
        itemStyle: { color: 'darkblue' },
        data: data.map(item => this.convPerc(item.selection))
      },
      {
        type: 'bar',
        stack: 'true',
        name: 'Interaction',
        itemStyle: { color: '#8c959b' },
        data: data.map(item => this.convPerc(item.interaction))
      },
      {
        type: 'scatter',
        symbol: 'diamond',
        symbolSize: 20,
        name: 'Total Attribution',
        itemStyle: { color: 'orange', opacity: 1 },
        data: data.map(item => this.convPerc(item.total))
      }
    ]
    return option
  }
}

function mapStateToProps(state) {
  return {
    pairs: state.performance.pairs,
    fund: state.performance.fund,
    bmk: state.performance.bmk,
    dates: state.performance.dates,
    categories: state.performance.categories,
    category: state.performance.category,
    categoryData: state.performance.categoryData,
    period: state.performance.period,
    periodData: state.performance.periodData,
    sortColumn: state.performance.sortColumn,
    sortDirection: state.performance.sortDirection
  }
}

export default withRouter(
  connect(mapStateToProps, {
    loadFromUrl,
    loadPairs,
    loadPerformance,
    setFund,
    setBmk,
    setDate,
    setPeriod,
    setCategory,
    setSort,
    saveToGA,
    loadAttributionExcel
  })(App)
)



// WEBPACK FOOTER //
// ./src/components/App/index.js